export default __webpack_public_path__ + "static/media/reset.cdc3d359.svg";